import { complement, isNil } from 'ramda'
import { notify } from '@/utils/notification'
import { Config } from './config'
import { Column, isSlot } from './column'
import { invoke, empty, Response } from './invoker'
import { decodeQuery, refreshQuery, QueryParam, Params } from './query'
import { Nilable } from '@/models/helpers/common'

export type Service<T> = {
  columns: Column<T>[]
  refresh: RefreshFn<T>
  /** parse from url query */
  query: QueryParam[]
}

type RefreshFn<T> = (Payload: Payload) => Promise<Response<T>>
type Payload = { current: number; pageSize: number; querys?: QueryParam[] }

export function createService<T>(config: Config<T>): Service<T> {
  let tempData = null as Nilable<Response<T>>

  async function refresh({
    current,
    pageSize,
    querys
  }: Payload): Promise<Response<T>> {
    const newQuerys = [
      ...(querys || []),
      ...((config.params && config.params.query) || [])
    ]

    const params: Params = {
      pageSize,
      current,
      ...config.params,
      query: newQuerys
    }

    refreshQuery(params)

    const { rows, total } = isNil(tempData) ? await fetch(params) : tempData

    const start = (current - 1) * pageSize
    const end = start + pageSize

    const needTemp = rows.length >= total
    tempData = needTemp ? { rows, total } : null

    const slice = needTemp ? rows.slice(start, end) : rows
    const formatted = slice.map(format)
    return { rows: formatted, total }
  }

  async function fetch(params?: Params) {
    try {
      return await invoke(config.data, params)
    } catch (e) {
      notify('获取列表失败', e)
      return empty
    }
  }

  function format(data: T) {
    const tmp = data as any
    config.columns
      .filter(complement(isSlot))
      .filter((a: any) => !!a.format)
      .filter((a: any) => tmp[a.prop] !== undefined)
      .map((a: any) => ((data as any)[a.prop] = a.format(tmp[a.prop])))

    return data
  }

  return {
    columns: config.columns,
    refresh,
    query: decodeQuery()
  }
}
